<script>
export default {
  name: 'ControlsBox',
};
</script>

<template lang="pug">
  div.controls-box.bg-black-overlay.pa4.animated.fadeIn._collision.flex.flex-column
    header.cf.mb4
      h1.title.fw7.f3.white
        slot(name="title")
    div.flex.flex-auto
      div.controlimgs.h-0.mr3.flex-shrink-0.w-60
        img.controllerimg.h-100.fit-contain.pa3(key="left", src="@/assets/Controller-Vive-Left-Description.svg")
        //- (see DEV-1176)
        //- UiTab.tab.h-100
        //-   img.controllerimg.h-100.fit-contain.pa3(key="left", src="@/assets/Controller-Vive-Left-Description.svg")
        //-   img.controllerimg.h-100.fit-contain.pa3(key="right", src="@/assets/Controller-Vive-Right-Description.svg")
      div.descriptions.lh-title.w-40.flex.flex-column
        scroll-element.flex-auto
          slot(name="controls")

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.controls-box {

}
</style>
